var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "16px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    viewBox: "0 0 16 16",
    width: "16px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,12c0,0.552-0.448,1-1,1H4c-0.551,0-1-0.448-1-1V4c0-0.551,0.449-1,1-1h5V2H4C2.897,2,2,2.897,2,4v8   c0,1.103,0.897,2,2,2h8c1.103,0,2-0.897,2-2V7h-1V12z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10,0 12.293,2.293 6.293,8.293 7.707,9.707 13.707,3.707 16,6 16,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.688a39f6e55ed7f39746b333218a7a63.svg";
export { ForwardRef as ReactComponent };